import React from 'react';
import { ProtectedRoutes } from '../context/ProtectedRoutes';
import Home from '../pages/Home.page';
import About from '../pages/About.page';
import Contact from '../pages/Contact.page';
import Login from '../pages/Login.page';
import SignUp from '../pages/SignUp.page';
import ErrorPage from '../pages/Error.page';
import RestApi from '../components/Rest_Api';
import GraphqlApi from '../components/Graphql_Api';

const Routes = [
  { path: '/', element: <Home /> },
  { path: '/about', element: <About /> },
  { path: '/contact', element: <Contact /> },
  { path: '/login', element: <Login /> },
  { path: '/signup', element: <SignUp /> },
  {
    path: '/rest-api/:id',
    element: (
      <ProtectedRoutes>
        <RestApi />
      </ProtectedRoutes>
    ),
  },
  {
    path: '/graphql-api/:id',
    element: (
      <ProtectedRoutes>
        <GraphqlApi />
      </ProtectedRoutes>
    ),
  },
  { path: '*', element: <ErrorPage /> },
];

export default Routes;
